export enum AccountType {
  Personal = 'Personal',
  Corporate = 'Corporate',
  Academic = 'Academic',
}

// for the record this is a horrible name
export enum AccountPlanType {
  Personal = 'Personal',
  Enterprise = 'Enterprise',
  Academic = 'Academic',
  Pro = 'Pro',
  Teams = 'Teams',
  Free = 'Free',
  ThirtyDayTrial = '30 Day Trial',
  Legacy = 'Legacy',
}

export type Account = {
  name: string;
  accountType: AccountType; // rename this to orgtype
  accountPlanType: AccountPlanType; // rename this to accountType
  id?: string;
  memberCount?: number | null;
  isEnterprise?: boolean;
  username: string;
  personalOrgId?: string;
  isDummyAccount?: boolean;
};

// The backend returns -1 for org-wide aggregate scalars (member count, seat
// usage) when the viewer is not allowed to read them on a hidden or redacted
// org. -1 is used instead of 0/null because 0 is a legitimate real value. Treat
// any negative (or missing) value as "withheld".
export const WITHHELD_AGGREGATE_VALUE = -1;

export const isAggregateWithheld = (value?: number | null): boolean =>
  value == null || value < 0;
